module.exports = __webpack_public_path__ + "img/yangImg1.a852ab10.jpg";